// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Switch/Switch.less
// module id = 236
// module chunks = 2